import { type SVGProps } from "react";

export const SmartRandomness = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M56 38C57.1045 38 58 38.8955 58 40V56C58 57.1045 57.1045 58 56 58H40C38.8955 58 38 57.1045 38 56C38 54.8955 38.8955 54 40 54H54V40C54 38.8955 54.8955 38 56 38Z"
        fill="#1FB787"
      />
      <path
        d="M56 38C57.1045 38 58 38.8955 58 40V56C58 57.1045 57.1045 58 56 58H40C38.8955 58 38 57.1045 38 56C38 54.8955 38.8955 54 40 54H54V40C54 38.8955 54.8955 38 56 38Z"
        stroke="#1FB787"
      />
      <path
        d="M38 8C38 6.89544 38.8955 6 40 6H56C57.1045 6 58 6.89544 58 8V23.9999C58 25.1045 57.1045 25.9999 56 25.9999C54.8955 25.9999 54 25.1045 54 23.9999V10H40C38.8955 10 38 9.10456 38 8Z"
        fill="#1FB787"
      />
      <path
        d="M57.4141 6.58578C58.1952 7.36682 58.1952 8.63317 57.4141 9.41421L9.41421 57.4143C8.63317 58.1954 7.36682 58.1954 6.58578 57.4143C5.80474 56.6332 5.80474 55.3668 6.58578 54.5858L54.5859 6.58578C55.3669 5.80474 56.6331 5.80474 57.4141 6.58578Z"
        fill="#1FB787"
      />
      <path
        d="M6.58578 6.58578C7.36682 5.80474 8.63317 5.80474 9.41421 6.58578L33.4141 30.5859C34.1952 31.3667 34.1952 32.6331 33.4141 33.4141C32.6331 34.1952 31.3669 34.1952 30.5859 33.4141L6.58578 9.41421C5.80474 8.63317 5.80474 7.36682 6.58578 6.58578ZM40.5859 40.5859C41.3669 39.8048 42.6331 39.8048 43.4141 40.5859L57.4141 54.5859C58.1952 55.3667 58.1952 56.6331 57.4141 57.4141C56.6331 58.1952 55.3669 58.1952 54.5859 57.4141L40.5859 43.4141C39.8048 42.6331 39.8048 41.3667 40.5859 40.5859Z"
        fill="#1FB787"
      />
    </svg>
  );
};
